const getExceptionSlots = (selectedDay, time) => {
  const d = selectedDay;
  let exceptionSlots = d.freeSpots;
  if (!d.exceptions) return d.freeSpots;
  for (let ex = 0; ex < d.exceptions.length; ex++) {
    const e = d.exceptions[ex].days;
    for (let exd = 0; exd < e.length; exd++) {
      if (e[exd].date == time) {
        exceptionSlots = d.exceptions[ex].participants;
      }
    }
  }
  return exceptionSlots;
};

export default getExceptionSlots;
